import { Box, styled, TextField } from '@mui/material';
import { GridContainer } from 'components/shared/Grid/Grid.components';

export const CompactGridContainer = styled(GridContainer)(({ theme }) => ({
  rowGap: theme.spacing(3)
}));

export const RecurrenceRepeatBox = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  height: '100%'
});

export const RecurrenceIntervalInput = styled(TextField)(({ theme }) => ({
  width: theme.spacing(4),
  margin: `0 ${theme.spacing(1)}`
}));

export const RecurrenceRepresentation = styled(Box)(({ theme }) => ({
  margin: theme.spacing(2)
}));

export const RecurrenceRepresentationRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  margin: theme.spacing(2),
  gap: theme.spacing(1)
}));
